import { Component, OnInit, Input } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { DischargeSummaryExtraDetails, DischargeSummaryExtraParameters, DefinalizeDetails } from './template.model';
import { ModalService } from '../../services/modal.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { DialogConfig } from '../dialog/dialog-config';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'kx-emr-template-view',
    templateUrl: './emr-template-view.component.html',
    styleUrls: ['./emr-template-view.component.scss'],
    standalone: false
})

export class EmrTemplateViewComponent implements OnInit {
  public show: boolean;
  public formData: any = false;
  public templates: any;
  public template: any = "";
  public cardData: any;
  public _currentTemplateName: string;
  public preFilledtemplates: Array<any> = [];
  public _currentData: any;
  public customButton: any;
  public _saveTemplateObj: any = {};
  public _bind_DDl_Req: object = {};
  public _bind_OldTempl_Req: object = {};
  public _currentTemplate: object = {};
  @Input() view: boolean = false;
  public form: boolean = false;
  public _currentPage: number = 0;
  public allTemplateCount: number;
  public showExtradetails: boolean = true;
  @Input() resource: any;

  @Input() bannerJson: any;
  public configJson = {
    showPreviousTemplates: true,
    showTemplateList: true,
    currentAction: 'ADD'
  }
  @Input() type: string = '';
  @Input() observationId: any;
  public scoreDataArray: Array<any> = [];
  dischargeSummaryFilled: any;
  dropdownDisable: any;
  config: any;
  dischargeSummaryExtraParameters: any;
  dischargeSummaryExtraDetails: any;
  doctorDataDischargeSummary: any;
  specialityDataDischargeSummary: any;
  definalizeDetails: any;
  blockData: any;

  constructor(
    private baseService: BaseService,
    public loader: LoaderService,
    public alerts: AlertsService,
    public storageService: StorageService,
    private smartModalService: SmartModalService,
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private authenticationService: AuthenticationService,
    private modalService: ModalService,
    public rolePermissionService: RolePermissionService,
    private dialogConfig: DialogConfig,
    public utilService?: UtilService
  ) {
    this.dischargeSummaryExtraDetails = new DischargeSummaryExtraDetails();
    this.dischargeSummaryExtraParameters = new DischargeSummaryExtraParameters();
    this.definalizeDetails = new DefinalizeDetails();
  }

  ngOnInit() {
    this.config = {
      "submitButton": true,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    // when coming from popup
    console.log("template data ->", this.resource)
    if (Object.keys(this.dialogConfig).length > 0)
      this['data'] = this.dialogConfig;
    if (this['data'])
      this.configJson = this['data']
    // when coming from redirect link
    else if (this.route.snapshot.data.hasOwnProperty('configJson')) {
      this.configJson = this.route.snapshot.data.configJson;
    }
    // when coming from tab
    else if (this.route.snapshot.queryParams.hasOwnProperty('tab_0'))
      this.configJson['type'] = this.route.snapshot.queryParams.tab_0
    else if (this.view == false && !this.observationId && this.resource != undefined)
      this.configJson['type'] = this.resource.input
    // tabName is id of tab

    // for view only when we open from selector
    if (this.view == true && this.observationId) {
      this.configJson['action'] = 'view';
      this.configJson['observation_id'] = this.observationId
      this.configJson['showPreviousTemplates'] = false,
        this.configJson['showTemplateList'] = false,
        this.configJson['type'] = this.type
    }

    if (this.authenticationService.getUserType() == 'patient') {
      this.getPatientData(this.authenticationService.getCurrentUser().user_id);
    }
    else {
      this.storageService.getSessionStorageData("currentData", (data) => { // getting user info
        if (data) {
          this.cardData = data;
          this.bindParameters();
        }
      });
    }
    
  }

  bindParameters() {
    var gender = '';
    if (this.cardData['patient_gender'] != "does not wish to disclose")
      gender = this.cardData['patient_gender'].replace(/ /g, "-");
    else
      gender = "non-disclose";

    this._bind_DDl_Req = {
      resource: "template",
      application: "form-template-engine",
      queryId: "GET_ALL",
      data: { filter: "templateType:" + this.configJson['type'] + (this.configJson['params'] == undefined ? (",gender.id:" + gender.toLowerCase() + ",patientType.id:" + this.cardData['patientType']) : this.configJson['params'].toLowerCase()) }
    }
    this._bind_OldTempl_Req = {
      resource: "observation_emr_templates",
      application: "emr",
      queryId: "GET_TEMPLATE_BY_UHID",
      data: {
        args: `uhId:${this.cardData['uhId']},templateType:${this.configJson['type']}`,
        page_size: 10,
        page_no: this._currentPage
      }
    }
    if (this.cardData['encounter_id'] != undefined && this.cardData['encounter_id'])
      this._bind_OldTempl_Req['data']['args'] = this._bind_OldTempl_Req['data']['args'] + ",encounter_id:" + this.cardData['encounter_id'] + ""
    if (this.configJson['type'] == 'discharge_summary') {
      this.dischargeSummaryExtraDetails = new DischargeSummaryExtraDetails();
      this.dischargeSummaryExtraParameters = new DischargeSummaryExtraParameters();
      this.getExtraDetailsForDischargeSummary()
    }
    if (this.configJson.showPreviousTemplates)
      this.gettingPreviousTemplates();
    if (this['data'] || this.configJson['action']) {
      var data = this['data'] ? this['data'] : this.configJson;
      if (data['action']) {
        if (data['action'] == 'edit') {
          this.editTemplate(this['data']['editData']);
        }
        else if (data['action'] == 'view') {
          var observation_id = this.configJson['observation_id'] ? this.configJson['observation_id'] : this.cardData['observation_id']
          this.viewByTemplateId(observation_id);
        }
        else
          this.getAllTemplates();
      }
    } else
      this.getAllTemplates();
  }


  async getPredefinedTemplateById(obj, type) {
    var data = { args: "id:" + obj['templateId'] }
    await this.baseService.getData(data, "", 'template', 'form-template-engine', 'GET_BY_ID').toPromise().then((result: any) => {
      if (result.errCode == 0 && result.count > 0) {
        var form = result.resource[0]
        if (type == 'edit') {
          if (this._currentTemplate['template']) {
            Object.keys(this._currentTemplate['template']).forEach(key => {
              form.blocks.forEach(element => {
                if (element.hasOwnProperty('block_api') && element.block_api.application)
                  this.setCustomName(element)
                element.fields.forEach(elementOne => {
                  if (elementOne.name == key) {
                    if (typeof obj['template'][key] == 'string' && elementOne.component == 'pullable') {
                      if (obj['template'][key] != '')
                        this._currentTemplate['template'][key] = JSON.parse(this._currentTemplate['template'][key]);
                      elementOne.pullableData['bannerJson'] = this.bannerJson;
                    }
                    elementOne.advanceTextData = this._currentTemplate['template'][key];
                    elementOne.default = this._currentTemplate['template'][key];
                  }
                });
              });
            })
          }
        } else if (type == 'view') {
          form.blocks.forEach(block => {
            block.fields.forEach(element => {
              if (obj['template']) {
                Object.keys(obj['template']).forEach(key => {
                  if (key == element.name && element.component == 'pullable') {
                    if (typeof obj['template'][key] == 'string' && obj['template'][key] != '')
                      obj['template'][key] = JSON.parse(obj['template'][key]);
                  }
                })
              }
            });
          });
        } else { }
        setTimeout(x => { return this.formData = form; });
        this._currentTemplateName = form.name;
        this.baseService.setTitle(this._currentTemplateName);
        if (obj['template']) {
          this._currentData = obj['template'];
        }
        if (obj['scoreBlockSumData']) {
          this._currentData.scoreBlockSumData = obj['scoreBlockSumData'];
        }
        this.template = "";
        this.loader.hideSpinner();
      }
    }, err => {
      this.alerts.error('There is Some Error...');
    })
    setTimeout(() => {
      this.showExtradetails = true;
    });
  }

  getAllTemplates() { // Binding  All template dropDown
    this.loader.showSpinner();
    this.baseService.get(this._bind_DDl_Req['queryId'], "", this._bind_DDl_Req['resource'], this._bind_DDl_Req['application'], this._bind_DDl_Req['data'].filter).subscribe(res => {
      if (res.hasOwnProperty('resource') && res.errCode == 0) {
        this.loader.hideSpinner();
        this.templates = res.resource;
        if (res.resource.length > 0) {
          if (this.configJson['args']) {
            this.template = res.resource.find(element => element.name == this.configJson['args']).id;
          }
          else
            this.template = res.resource[0].id;
          this.valueChange(this.template)
        }
      }
    }, (err: Error) => {
      this.loader.hideSpinner();
    })
    this.loader.hideSpinner();
  }

  valueChange(event: any) { //  on  Template change
    this.formData = false;
    this.view = false;
    this.loader.showSpinner();
    let promiseObj = []
    if (event) {
      var data = this.search(this.template, this.templates, 'id');
      if (data.hasOwnProperty('blocks') && data.blocks.length > 0) {
        /////////Used for filling data in template block using API -- BeingUsed in ambulance for now ///////
        if (data.blocks.filter(elem => (elem.block_api != undefined && JSON.stringify(elem.block_api) != '{}')).length == 0)
          this._currentData = {}
        data.blocks.forEach((element, index) => {
          if (element.hasOwnProperty('block_api') && JSON.stringify(element.block_api) != '{}') {
            element.fields.forEach(subElem => {
              subElem.proxy_name = subElem.title
            })
            if (element.block_api.args)
              element.block_api.args = this.baseService.buildDyanamicStr(element.block_api.args, { data: JSON.parse(sessionStorage.getItem('currentData')) })
            if (element.block_api.filter)
              element.block_api.filter = this.baseService.buildDyanamicStr(element.block_api.filter, { data: JSON.parse(sessionStorage.getItem('currentData')) })
            let obj = { args: element.block_api.args, filter: element.block_api.filter }
            promiseObj.push(this.getBlockDataPromise(obj, element))
          }
        });
        if (promiseObj.length > 0) {
          Promise.all(promiseObj).then(() => {
            this._currentData = this.blockData
          })
        }
        //////////////////////////////////////////////////////////////////////////////////////////
        this.show = true;
        if (this.bannerJson != undefined)
          data.bannerJson = this.bannerJson;
        setTimeout(x => { return this.formData = data; });
        this._currentTemplateName = data.name;
        this.baseService.setTitle(this._currentTemplateName);
      } else {
        this._currentTemplateName = 'No Template Found for -- ' + data.name;
        this.show = false;
      }
    }
    this.form = true;
    if (this.configJson['customButton']) {
      this.customButton = this.configJson['customButton']
    }
    else {
      this.customButton = {
        "Add": [{
          "label": "Draft",
          "action": "draft",
          "icon": "fa fa-save"
        }, {
          "label": "Final",
          "action": "final",
          "icon": "fa fa-check"
        }]
      };
    }

    this.loader.hideSpinner();
  }
  settingArgsActionsQueryIDBasedOnButtonTypeClick(action, data, tabName) {
    if (this.formData != undefined && this.formData) {
      this.formData.blocks.forEach(block => {
        block.fields.forEach(element => {
          if (element.hasOwnProperty('proxy_name')) {
            data.result[element.name] = data.result[element.proxy_name]
            delete data.result[element.proxy_name]
          }
          Object.keys(data.result).forEach(key => {
            if (key == element.name && element.component == 'pullable')
              if (typeof data.result[key] == 'object')
                data.result[key] = JSON.stringify(data.result[key]);
          })
        });
      });
    }
    if (action == "final" || (action == "draft" && this.template)) {
      let obj = {
        "templateId": this.search(this.template, this.templates, 'id').id,
        "template": data.result,
        "uhId": this.cardData.uhId,
        "templateName": this.search(this.template, this.templates, 'id').name,
        "templateType": this.search(this.template, this.templates, 'id').templateType,
        "status": action,
        "telecom": this.cardData['telecom'],
        "patientType": this.cardData.patientType,
        "orderId": this.cardData.orderId != undefined && this.cardData.orderId ? this.cardData.orderId : ""
      }
      if (this.cardData.encounter_id != undefined && this.cardData.encounter_id) {
        obj["encounter_id"] = this.cardData.encounter_id;
      }
      if (this.configJson['type'] == 'discharge_summary') {
        this.sendExtraDetails(obj, 'TemplateBaseOnDischargeSummary');
      } else
        this.saveUpdateDraftTemplate(obj, "AddTemplate", "emr", "observation_emr_templates");
    } else {
      if (action != 'draft')
        action = 'final'
      let obj = {
        "templateId": this._currentTemplate['templateId'],
        "template": data.result,
        "uhId": this.cardData.uhId,
        "templateName": this._currentTemplate['templateName'],
        "templateType": this._currentTemplate['templateType'],
        "status": action,
        "id": this._currentTemplate['id'],
        "orderId": this.cardData.orderId != undefined && this.cardData.orderId ? this.cardData.orderId : "",
        "patientType": this.cardData.patientType
      }
      if (this.cardData.encounter_id != undefined && this.cardData.encounter_id) {
        obj["encounter_id"] = this.cardData.encounter_id;
      }
      if (this.configJson['type'] == 'discharge_summary')
        this.sendExtraDetails(obj, 'TemplateUpdateBaseOnDischargeSummary');
      else
        this.saveUpdateDraftTemplate(obj, "TemplateUpdateBaseOnId", "emr", "observation_emr_templates");
    }
  }

  onSaveFinished(data: any) {
    console.log("data is_____________________", data);
    this.settingArgsActionsQueryIDBasedOnButtonTypeClick(data.currentBtnVal.action, data, this.configJson['type'])
  }

  scoreValueEvent(data: any) {
    if (this.scoreDataArray.length > 0) {
      let scoredata = this.scoreDataArray.find(x => x.blockId === data.blockId);
      if (scoredata) {
        scoredata.blockRiskLevel = data.blockRiskLevel;
        scoredata.blockSum = data.blockSum;
        scoredata.blockData = data.blockData;
      } else {
        this.scoreDataArray.push(data);
      }
    } else {
      this.scoreDataArray.push(data);
    }
  }
  saveUpdateDraftTemplate(obj, action, application, resource) {
    obj['patient_name'] = this.cardData.patient_name,
      obj['patient_type'] = this.cardData.patient_type,
      obj['patient_gender'] = this.cardData.patient_gender,
      obj['patient_age'] = this.cardData.patient_age,
      obj['orderingDoctorName'] = this.cardData.currentTreatingDoctor != undefined ? this.cardData.currentTreatingDoctor : this.cardData.treatingDoctor,
      obj['orderingDoctorId'] = this.cardData.currentTreatingDoctorId != undefined ? this.cardData.currentTreatingDoctorId : this.cardData.treatingDoctorId,
      obj['admittingDoctor'] = this.cardData.admittingDoctor != undefined ? this.cardData.admittingDoctor : this.cardData.admittingDoctor,
      obj['admittingDoctorId'] = this.cardData.admittingDoctorId != undefined ? this.cardData.admittingDoctorId : this.cardData.admittingDoctorId,
      obj['admittingDoctorSpeciality'] = this.cardData.admittingDoctorSpeciality != undefined ? this.cardData.admittingDoctorSpeciality : this.cardData.admittingDoctorSpeciality,
      obj['admittingDoctorSpecialityId'] = this.cardData.admittingDoctorSpecialityId != undefined ? this.cardData.admittingDoctorSpecialityId : this.cardData.admittingDoctorSpecialityId,
      obj['currentTreatingDoctorSpeciality'] = this.cardData.currentTreatingDoctorSpeciality != undefined ? this.cardData.currentTreatingDoctorSpeciality : this.cardData.currentTreatingDoctorSpeciality,
      obj['currentTreatingDoctorSpecialityId'] = this.cardData.currentTreatingDoctorSpecialityId != undefined ? this.cardData.currentTreatingDoctorSpecialityId : this.cardData.currentTreatingDoctorSpecialityId,
      obj['currentTreatingDoctor'] = this.cardData.currentTreatingDoctor != undefined ? this.cardData.currentTreatingDoctor : this.cardData.currentTreatingDoctor,
      obj['currentTreatingDoctorId'] = this.cardData.currentTreatingDoctorId != undefined ? this.cardData.currentTreatingDoctorId : this.cardData.currentTreatingDoctorId
    this.loader.showSpinner();
    if (this.scoreDataArray.length > 0) {
      obj = { ...obj, ...{ "scoreBlockSumData": this.scoreDataArray } };
    }
    this.baseService.action(obj, action, application, resource).subscribe(res => {
      if (res.hasOwnProperty('resource') && res.errCode == 0) {
        this.alerts.success("Template Save Successfully...");
        if (this['data']) {
          this.loader.hideSpinner();
          this.smartModalService.sendResult(res.resource);
        } else {
          if (this.configJson['dataSrc']) {
            this.cardData['observation_id'] = res.resource[0].id;
            this.baseService.action(this.cardData, this.configJson['dataSrc'].action, this.configJson['dataSrc'].application, this.configJson['dataSrc'].resource).subscribe(response => {
              console.log("Update -", response);
              this.loader.hideSpinner();
              if (this.configJson['redirect'] != undefined && this.configJson['redirect'] == true) {
                this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl)
              }
            });
          }
          else {
            this.bindParameters();
            this.loader.hideSpinner();
            this.form = false;
            this.view = false;
          }
        }
      } else {
        this.alerts.error(res.message)
        this.loader.hideSpinner();
      }
    }, (err) => {
      this.alerts.error("Error while saving data in DB.");
      this.loader.hideSpinner();
    })
  }
  // get Previous Templates list
  gettingPreviousTemplates() {
    this.loader.showSpinner();
    this.baseService.getData(this._bind_OldTempl_Req['data'], this._bind_OldTempl_Req['filterParams'], this._bind_OldTempl_Req['resource'], this._bind_OldTempl_Req['application'], this._bind_OldTempl_Req['queryId']).subscribe((res: any) => {
      if (res.hasOwnProperty('resource') && res.errCode == 0) {
        if (res.count > 0 && this.configJson['type'] == 'discharge_summary') {
          this.dischargeSummaryFilled = true;
          this.dropdownDisable = true;
        } else {
          this.dropdownDisable = false;
          this.dischargeSummaryFilled = false;
        }
        this.preFilledtemplates = res.resource;
        this.allTemplateCount = res.count
        this.loader.hideSpinner();
      }
    }, (err: Error) => {
      this.loader.hideSpinner();
    })
  }

  // Edit Template
  editTemplate(obj: object) {
    this.showExtradetails = false;
    this.loader.showSpinner();
    this.formData = false;
    this.view = false;
    this.form = true;
    this.show = true;
    this._currentTemplate = obj;
    if (this.configJson['type'] == "discharge_summary")
      this.editViewTemplateExtraFields(obj, 'edit');
    this.dischargeSummaryFilled = false;
    this.getPredefinedTemplateById(obj, 'edit');
    if (this.configJson['customButton'])
      this.customButton = this.configJson['customButton']
    else {
      this.customButton = {
        "Add": [{
          "label": "Draft",
          "action": "draft"
        }, {
          "label": "Update & Save",
          "action": "modify"
        }]
      };
    }
  }

  // view template from previous list
  viewTemplate(obj: object) {
    this.definalizeDetails = new DefinalizeDetails();
    if (!this.observationId)
      this.observationId = obj['id']
    this.formData = false;
    this.form = false;
    this.loader.showSpinner();
    this._currentTemplate = obj;
    if (this.configJson['type'] == "discharge_summary")
      this.editViewTemplateExtraFields(obj, 'view');
    this.getPredefinedTemplateById(obj, 'view')
    this.view = true;
  }

  goPrev() {
    if (this._currentPage && this._currentPage != 0 && this.allTemplateCount > this._currentPage) {
      this._currentPage = this._currentPage - 1;
      this._bind_OldTempl_Req['data']['page_no'] = this._currentPage;
      return this.bindParameters();
    }
  }

  goNext() {
    this._currentPage = this._currentPage + 1;
    this._bind_OldTempl_Req['data']['page_no'] = this._currentPage;
    return this.bindParameters();
  }

  getClassToEnableDisableIcon() { // setting goNext icon disabled if datasource reaches maximum limit
    if (this.allTemplateCount > 0) {
      var lastPage = this.allTemplateCount / 10;
      if (lastPage > this._currentPage + 1) {
        return null;
      } else {
        return true;
      }
    }
  }

  onScrollList(event) {
    if (event === 100) {
      console.log("Scroll hor ha hu");
    }
  }

  // retrive template from observationId
  viewByTemplateId(observationId) {
    this.observationId = observationId
    let data = {
      args: `uhId:${this.cardData.uhId},observationId:${observationId},templateType:${this.configJson['type']}`,
      page_size: 10,
      page_no: 0
    }
    this.baseService.getData(data, "", 'observation_emr_templates', 'emr', 'GET_TEMPLATE_BY_UHID').subscribe((result: any) => {
      if (result.errCode == 0 && result.count > 0)
        this.viewTemplate(result.resource[0]);
    }, err => {
      this.alerts.error('There is Some Error...');
      this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
    })
  }
  // based on id, retrieve object
  search(nameKey, myArray, searchKey, type?: any) {
    let obj = myArray.find(o => o[searchKey] === nameKey);
    if (type != undefined && type == 'qualification') {
      var qualification = ""
      if (obj[type] != undefined) {
        obj[type].forEach((element, i) => {
          qualification = qualification + element.text + (i == obj[type].length - 1 ? "" : ",");
        });
      }
      return qualification;
    } else
      return obj;
  }

  printTemplate(obj) {
    var type = 'templateEMR';
    if (this.configJson['type'] == 'discharge_summary')
      type = 'dischargeEMR';
    window.open(location.origin + "/printengine/api/v1/template/print?queryId=GET_TEMPLATE_WITH_ANS&args=id:" + obj['id'] + ",reportTemplateId:" + type + ",primaryKeyIdentifier:" + obj['id'] + ",contentType:pdf,facility_id:" + this.appService.getOrganization().org_id, '_blank');
  }

  getPatientData(id) {
    let data = { args: "id:" + id }
    this.baseService.getData(data, "", "patient", "patient-registration", "GET_BY_ID").subscribe(
      res => {
        if (res) {
          this.cardData = res.resource[0];
          this.bindParameters();
        }
      })
  }

  // Extra Features For Discharege Summary Only
  sendExtraDetails(obj, action) {
    obj['referBy'] = this.cardData['referralName'] != undefined ? this.cardData['referralName'] : '';
    obj['payer_name'] = this.cardData['payer_name'] != undefined ? this.cardData['payer_name'] : '';
    obj['payer_type'] = this.cardData['payer_type'] != undefined ? this.cardData['payer_type'] : '';
    obj['admissionType'] = this.cardData['admissionType_value'] != undefined ? this.cardData['admissionType_value'] : '';
    obj['bedNo'] = this.cardData['bed'] != undefined ? this.cardData['bed'] : '';
    obj['ward'] = this.cardData['ward'] != undefined ? this.cardData['ward'] : '';

    obj['admissionDateTime'] = this.cardData['g_creation_time'] != undefined ? this.cardData['g_creation_time'] : '';
    if (this.cardData['dischargeDate'] != undefined)
      obj['dischargeDateTime'] = this.cardData['dischargeDate']
    obj['dischargeSummaryExtraDetails'] = Object.assign({}, this.dischargeSummaryExtraDetails);
    if (obj['dischargeSummaryExtraDetails'] != undefined && obj['dischargeSummaryExtraDetails'].isAdmittingDoctor == true) { } else {
      delete obj['dischargeSummaryExtraDetails'].admittingDetails;
    }
    if (obj['dischargeSummaryExtraDetails'] != undefined && obj['dischargeSummaryExtraDetails'].isTreatingDoctor == true) { } else {
      delete obj['dischargeSummaryExtraDetails'].treatingDetails;
    }
    if (obj.dischargeSummaryExtraDetails['expectedDischargeDateAndTime'] != undefined)
      obj.dischargeSummaryExtraDetails['expectedDischargeDateAndTime'] = obj.dischargeSummaryExtraDetails['expectedDischargeDateAndTime'] != "" ? obj.dischargeSummaryExtraDetails['expectedDischargeDateAndTime'] : null
    this.saveUpdateDraftTemplate(obj, action, "emr", "observation_emr_templates");
  }

  getExtraDetailsForDischargeSummary(type?: any) {
    this.getPrintHeaders();
    Object.keys(this.dischargeSummaryExtraDetails).forEach(key => {
      if (this.dischargeSummaryExtraDetails[key] != null && typeof this.dischargeSummaryExtraDetails[key] == 'object') {
        Object.keys(this.dischargeSummaryExtraDetails[key]).forEach(childKey => {
          if (this.cardData[childKey] != undefined && this.cardData[childKey] && type == undefined)
            this.dischargeSummaryExtraDetails[key][childKey] = this.cardData[childKey];
        })
      } else {
        if ((this.cardData[key] != undefined && this.cardData[key]) && (type == undefined || key == 'deathDateTime' || key == 'dischargeType'))
          this.dischargeSummaryExtraDetails[key] = this.cardData[key];
      }
    });
    this.baseService.getData({ args: "facility_master_type:SPECIALITYMASTER" }, "", "facility_master", "facility-management", "getOrganizationSetup").subscribe((res: any) => {
      if (res.hasOwnProperty('resource') && res.errCode == 0) {
        this.specialityDataDischargeSummary = res.resource;
        if (this.dischargeSummaryExtraDetails.treatingDetails != undefined && this.dischargeSummaryExtraDetails.treatingDetails.currentTreatingDoctorSpecialityId)
          this.doctorDetails(this.dischargeSummaryExtraDetails.treatingDetails.currentTreatingDoctorSpecialityId, 'treatingDoctorsDischargeSummary', undefined, 'treatingDetails', 'currentTreatingDoctor', this.dischargeSummaryExtraDetails.treatingDetails.currentTreatingDoctorId)
        if (this.dischargeSummaryExtraDetails.admittingDetails != undefined && this.dischargeSummaryExtraDetails.admittingDetails.admittingDoctorSpecialityId)
          this.doctorDetails(this.dischargeSummaryExtraDetails.admittingDetails.admittingDoctorSpecialityId, 'admittingDoctorsDischargeSummary', undefined, 'admittingDetails', 'admittingDoctor', this.dischargeSummaryExtraDetails.admittingDetails.admittingDoctorId)
      }
    }, (err: Error) => {
    })
  }

  getPrintHeaders() {
    this.baseService.getData({ args: "resourceId:dischargeSummaryHeader,system:karexpert" }, "", "valueset", "system-management", "get_valueset_by_id_flat").subscribe((res: any) => {
      if (res.hasOwnProperty('resource') && res.errCode == 0) {
        this.dischargeSummaryExtraParameters.printHeaders = res.resource;
      }
    }, (err: Error) => { })
  }
  async doctorDetails(specialityId, type?: any, order?: any, saveKey?: any, childKey?: any, doctorId?: any) {
    let ind = order != undefined ? order : 1;
    await setTimeout(() => {
      this.baseService.getData({ args: "speciality_id:" + specialityId + "", filter: "userRole:Doctor" + "" }, "", "practitioner_facility_details_doctor", "facility-management", "GET_DOCTOR_BY_SPECIALITY").subscribe((res: any) => {
        if (res.hasOwnProperty('resource') && res.errCode == 0) {
          if (order != undefined) {
            if (this.dischargeSummaryExtraParameters[type][order] != undefined)
              this.dischargeSummaryExtraParameters[type][order] = res.resource;
            else
              this.dischargeSummaryExtraParameters[type].push(res.resource)
            if (saveKey != undefined)
              this.dischargeSummaryExtraDetails[saveKey][order].speciality = this.search(specialityId, this.specialityDataDischargeSummary, 'id').display
          }
          else {
            this.dischargeSummaryExtraParameters[type] = res.resource
            if (saveKey != undefined) {
              this.dischargeSummaryExtraDetails[saveKey][childKey] = this.search(specialityId, this.specialityDataDischargeSummary, 'id').display
            }
          }
          if (doctorId != undefined)
            this.changeDoctor(doctorId, type, undefined, saveKey, childKey)
        }
      }, (err: Error) => {
      })
    }, 1000 * ind);
  }

  changeDoctor(doctorId, type, order, saveKey, childKey) {
    if (order != undefined) {
      this.dischargeSummaryExtraDetails[saveKey][order].doctor = this.search(doctorId, this.dischargeSummaryExtraParameters[type][order], 'practitioner_id').display_name
      this.dischargeSummaryExtraDetails[saveKey][order]['qualification'] = this.search(doctorId, this.dischargeSummaryExtraParameters[type][order], 'practitioner_id', "qualification")
    } else {
      this.dischargeSummaryExtraDetails[saveKey][childKey] = this.search(doctorId, this.dischargeSummaryExtraParameters[type], 'practitioner_id').display_name
      this.dischargeSummaryExtraDetails[saveKey]['qualification'] = this.search(doctorId, this.dischargeSummaryExtraParameters[type], 'practitioner_id', "qualification")
    }
  }

  addDropdownForDischargeSummary() {
    let keyOrder = this.dischargeSummaryExtraDetails.additionalDoctorDetails.length + 1;
    let obj = {
      order: keyOrder,
      specialityId: '',
      speciality: '',
      doctorId: '',
      doctor: '',
      qualification: ''
    }
    this.dischargeSummaryExtraDetails.additionalDoctorDetails.push(obj);
    this.dischargeSummaryExtraParameters.additionalDoctorsDischargeSummary.push([])
  }
  editViewTemplateExtraFields(obj, type) {
    this.dischargeSummaryExtraDetails = new DischargeSummaryExtraDetails();
    this.dischargeSummaryExtraDetails = obj.dischargeSummaryExtraDetails != undefined ? obj.dischargeSummaryExtraDetails : new DischargeSummaryExtraDetails();
    if (this.dischargeSummaryExtraDetails.dischargeType != undefined)
      this.dischargeSummaryExtraDetails.dischargeType = (this.dischargeSummaryExtraDetails['dischargeType'].toLowerCase() != 'expired' && this.cardData['dischargeType'] != undefined) ? this.cardData['dischargeType'] : '';
    if (!this.dischargeSummaryExtraDetails.isAdmittingDoctor) {
      this.dischargeSummaryExtraDetails.admittingDetails = new DischargeSummaryExtraDetails().admittingDetails;
    }

    if (!this.dischargeSummaryExtraDetails.isTreatingDoctor)
      this.dischargeSummaryExtraDetails.treatingDetails = new DischargeSummaryExtraDetails().treatingDetails
    this.getExtraDetailsForDischargeSummary(type);
    // this.setAdmittingDr(obj);
    this.dischargeSummaryExtraDetails.additionalDoctorDetails.forEach((order, index) => {
      this.doctorDetails(order.specialityId, 'additionalDoctorsDischargeSummary', index, 'additionalDoctorDetails')
    });
  }

  definalizeSummary(item) {
    this.definalizeDetails.isDefinalize = true;
    this.definalizeDetails.id = item['id']
  }

  definalizeDetailsOfSummary() {
    this.baseService.action(this.definalizeDetails, "DischargeSummaryDefinalize", "emr", "observation_emr_templates").subscribe(res => {
      if (res.errCode == 0) {
        this.alerts.info("Discharge Summary DeFinalize Successfully...");
        this.definalizeDetails = new DefinalizeDetails();
        this.bindParameters();
      } else {
        this.alerts.error("There is some error to definalize summary..")
      }
    })
  }

  deleteDraftTemplate(template) {
    this.viewTemplate(template);
    this.modalService.confirm("DELETE", "Do you really want to delete this Template").subscribe(result => {
      if (result) {
        this.baseService.action({ id: template.id }, 'DeleteTemplate', "emr", "observation_emr_templates").subscribe(res => {
          if (res.errCode != -1) {
            this.template = ""
            this.bindParameters();
            this.alerts.success("Deleted Successfully...")
          } else
            this.alerts.error("There is some error to delete template...")
        })
      }
    })
  }

  getDischargeType(event) {
    if (event.target.checked == undefined || event.target.checked) {
      this.dischargeSummaryExtraDetails.dischargeType = "Expired"
    } else {
      this.dischargeSummaryExtraDetails.dischargeType = this.cardData['dischargeType'] != undefined ? this.cardData['dischargeType'] : ''
    }
  }

  checkPermission(actions, type) {
    actions = actions.split(",");
    var valid;
    valid = actions.filter(element => this.rolePermissionService.checkAccessPermission(element, this.configJson['type']) == true)
    if (valid.length > 0 && (type == undefined || type == "or"))
      return true;
    else if (this['data'] || this.type != "")
      return true;
    else
      return false;
  }

  removeAdditionalDoctorSpeciality(obj, i) {
    console.log(obj, 'obj');
    setTimeout(() => {
      var index = this.dischargeSummaryExtraDetails.additionalDoctorDetails.indexOf(obj);
      if (index > -1) {
        this.dischargeSummaryExtraDetails.additionalDoctorDetails.splice(index, 1);
        this.dischargeSummaryExtraParameters.additionalDoctorsDischargeSummary.splice(index, 1)
      }
    })
  }

  selectDateTime(event) {
    if (typeof (event) == 'number') {
      let date = new Date(event);
      if (event != null && date.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
        setTimeout(() => {
          this.alerts.error("Expected Date of Discharge should be greater than current date")
          this.dischargeSummaryExtraDetails.expectedDischargeDateAndTime = this.cardData['expectedDischargeDateAndTime'];
        })
      }
    } else {
      this.dischargeSummaryExtraDetails.expectedDischargeDateAndTime = null
    }
  }

  setCustomName(block) {
    block.fields.forEach(element => {
      element.name = element.title
    });
  }
  questionValueChanged(e: any) {
    if (e.question.val != undefined) {
      let arrayVal: any = "";
      if (e.question != undefined && e.question.question.dependents != undefined && e.question.question.dependents.length) {
        for (let index = 0; index < e.question.question.dependents.length; index++) {
          var dependent = e.question.question.dependents[index];
          arrayVal = dependent.value;
          if (dependent.action != undefined) {
            if (typeof (e.question.val) != 'string')
              e.question.val = e.question.val.toString()
            if (dependent.dependent_field != undefined && this.formData != undefined && this.formData) {
              let matched = e.question.val === arrayVal
              this.formData.blocks.forEach(block => {
                block.fields.forEach((element) => {
                  if (element['title'] == dependent.dependent_field) {
                    if (matched) {
                      switch (dependent.action) {
                        case 'enable':
                          this.setFieldDisabled(e.form.controls[element['name']], false, element['required'])
                          break;
                        case 'disable':
                          this.setFieldDisabled(e.form.controls[element['name']], true, element['required'])
                          break;
                        case 'visible':
                          this.setFormFieldVisibility(e.form.controls[element['name']], true, element['required'])
                          break;
                        case 'invisible':
                          this.setFormFieldVisibility(e.form.controls[element['name']], false, element['required'])
                          break;
                        default:
                          break;
                      }
                    }
                    else {
                      switch (dependent.action) {
                        case 'enable':
                          this.setFieldDisabled(e.form.controls[element['name']], true, element['required'])
                          break;
                        case 'disable':
                          this.setFieldDisabled(e.form.controls[element['name']], false, element['required'])
                          break;
                        case 'visible':
                          this.setFormFieldVisibility(e.form.controls[element['name']], false, element['required'])
                          break;
                        case 'invisible':
                          this.setFormFieldVisibility(e.form.controls[element['name']], true, element['required'])
                          break;
                        default:
                          break;
                      }
                    }

                  }
                });
              })
            }
          }
        }
      }
    }

  }

  setFieldDisabled(field, matched, is_required) {
    if (matched === true) {
      field.disable()
      if (field && field.question_component && field.question_component.question)
        field.question_component.question.disabled = true
    }
    else {
      field.enable()
      if (field && field.question_component && field.question_component.question)
        field.question_component.question.disabled = false
    }
    field.question_component.question.required = is_required
  }
  setFormFieldVisibility(field, matched, is_required) {
    if (field && field.question_component && field.question_component.question) {
      field.question_component.question.visible = matched
      if (matched === false && field.question_component.question.required === true)
        field.question_component.question.required = false
      if (matched === true && field.question_component.question.required === false)
        field.question_component.question.required = is_required
    }
  }
  getBlockDataPromise(obj, element) {
    return new Promise<void>((resolve, reject) => {
      this.baseService.getData(obj, '', element.block_api.resource, element.block_api.application, element.block_api.query_id).subscribe(res => {
        if (element.block_api.dataKey && res.resource[0]) {
          this.blockData = { ...this.blockData, ...res.resource[0][element.block_api.dataKey] }
        }
        else {
          this.blockData = { ...this.blockData, ...res.resource[0] }
        }
        resolve()
      })
    })
  }
  listResource(){
    if(this.route.snapshot.queryParams.hasOwnProperty('returnUrl'))
    this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl)
  }

}
